export const pixels = {
    mobile: 768,
    tablet: 1000,
}

export const css = {
    mobile: `${pixels.mobile}px`,
    tablet: `${pixels.tablet}px`,
}
